import { ImageSkeleton, LineSkeleton } from '@monoimin/atoms';

export const RealEstateCardSkeleton = () => {
  return (
    <div className='flex gap-4 flex-wrap md:flex-nowrap'>
      <ImageSkeleton className='md:h-[180px] aspect-[16/10] w-full min-w-full md:max-w-[288px]' />
      <div className='flex flex-col py-3 w-full relative'>
        <LineSkeleton variant='h4' className='w-4/12' />
        <LineSkeleton variant='caption' className='mt-5 w-full' />
        <LineSkeleton variant='caption' className='mt-5 w-6/12' />
        <div className='absolute bottom-3 flex justify-between w-full'>
          <LineSkeleton variant='caption' className='w-4/12' />
          <LineSkeleton variant='caption' className='w-4/12' />
        </div>
      </div>
    </div>
  );
};
